// @ts-ignore - no types for an image.
import {
    BUSINESS_UNIT_ADROLL,
    BUSINESS_UNIT_ROLLWORKS, // @ts-ignore - no types for ar-style-base
} from '@nextroll/ar-style-base';

// @ts-ignore - no types for an image.
import LogoAlgaeCal from './assets/standard-sign-up/logo-algaecal.png';
// @ts-ignore - no types for an image.
import LogoBombora from './assets/standard-sign-up/logo-bombora.png';
// @ts-ignore - no types for an image.
import LogoCoupa from './assets/standard-sign-up/logo-coupa.png';
// @ts-ignore - no types for an image.
import LogoFPMarkets from './assets/standard-sign-up/logo-fpmarkets.png';
// @ts-ignore - no types for an image.
import LogoG2 from './assets/standard-sign-up/logo-g2.png';
// @ts-ignore - no types for an image.
import LogoKNB from './assets/standard-sign-up/logo-knb.png';
// @ts-ignore - no types for an image.
import LogoOkta from './assets/standard-sign-up/logo-okta.png';
// @ts-ignore - no types for an image.
import LogoRMS from './assets/standard-sign-up/logo-rms.png';
// @ts-ignore - no types for an image.
import MetricsUIRW from './assets/standard-sign-up/metrics-ui-rw.png';

export enum API_STATUSES {
    IDLE = 'IDLE',
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS',
    IN_PROGRESS = 'IN_PROGRESS',
}

// BU-related constants.
export const BU_ADROLL = BUSINESS_UNIT_ADROLL as 'adroll';
export const BU_ROLLWORKS = BUSINESS_UNIT_ROLLWORKS as 'rollworks';

export type SupportedBUs = typeof BU_ADROLL | typeof BU_ROLLWORKS;

export const SUPPORT_EMAIL_ADDRESS = {
    [BU_ADROLL]: 'support@adroll.com',
    [BU_ROLLWORKS]: 'support@rollworks.com',
};

export const MARKETING_WEBSITE_URLS = {
    [BU_ADROLL]: 'https://www.adroll.com/',
    [BU_ROLLWORKS]: 'http://rollworks.com/',
};

export const BUSINESS_UNIT_NAMES = {
    [BU_ADROLL]: 'AdRoll',
    [BU_ROLLWORKS]: 'AdRoll ABM',
};

export const NORTH_AMERICAN_COUNTRIES = ['US', 'CA'];

export const PHONE_NUMBER_PLACEHOLDER = '415-555-5555';

export const EMAIL_METHOD = 'tfa_email_enabled';
export const SMS_METHOD = 'tfa_sms_enabled';
export const GAPP_METHOD = 'tfa_google_authenticator_enabled';

export enum RememberMyDeviceStatuses {
    expired = 'expired',
    invalid = 'invalid',
    unknown = 'unknown',
}

export enum SignUpModes {
    STANDARD = 'standard',
    SHOPIFY = 'shopify',
}

export enum EmailVerificationStatuses {
    // From URL. ev_succeeded is missing because we want to double-confirm by using status API.
    EV_CANCELLED = 'ev_cancelled',
    EV_EXPIRED = 'ev_expired',
    EV_NOT_FOUND = 'ev_not_found',
    EV_SYSTEM_ERROR = 'ev_system_error',
    // From /api/v1/email_verification/status API
    CANCELLED = 'canceled',
    EXPIRED = 'expired',
    PENDING = 'pending',
    VERIFIED = 'verified',
}

export enum EmailVerificationSources {
    SIGNUP_RESEND = 'signup_resend',
}

export enum PersonalEmailProviderDomains {
    GMAIL = 'gmail.com',
    YAHOO = 'yahoo.com',
    OUTLOOK = 'outlook.com',
}

export enum InternalEmailProviderDomains {
    ADROLL = 'adroll.com',
    ROLLWORKS = 'rollworks.com',
    NEXTROLL = 'nextroll.com',
}

export const SIGNUP_TRUSTED_BRANDS = {
    [BU_ROLLWORKS]: [
        { name: 'Coupa', logo: `${process.env.STATIC_PATH}${LogoCoupa}` },
        { name: 'Okta', logo: `${process.env.STATIC_PATH}${LogoOkta}` },
        { name: 'G2', logo: `${process.env.STATIC_PATH}${LogoG2}` },
        { name: 'Bombora', logo: `${process.env.STATIC_PATH}${LogoBombora}` },
    ],
    [BU_ADROLL]: [
        { name: 'AlgaeCal', logo: `${process.env.STATIC_PATH}${LogoAlgaeCal}` },
        { name: 'KNB', logo: `${process.env.STATIC_PATH}${LogoKNB}` },
        { name: 'RMS', logo: `${process.env.STATIC_PATH}${LogoRMS}` },
        {
            name: 'FPMarkets',
            logo: `${process.env.STATIC_PATH}${LogoFPMarkets}`,
        },
    ],
} as Record<SupportedBUs, { name: string; logo: string }[]>;
